// src/components/topNavbarTool/EnableDarkTheme.jsx
import { useEffect } from "react";
import "../../styles/darkTheme.css"; // <-- full theme file

export default function EnableDarkTheme({ isDark, setIsDark }) {
  useEffect(() => {
    if (isDark) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [isDark]);
  return null;
}